import { useQuery } from '@tanstack/react-query';
import { getOrderHistory, type OrderHistoryParams, type OrderHistoryResponse } from '../services/OrderHistoryService';

export function useOrderHistory(params: OrderHistoryParams) {
  return useQuery<OrderHistoryResponse>({
    queryKey: ['orderHistory', params],
    queryFn: () => getOrderHistory(params),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
